import { supportedFileExtensions } from '~/common/constants/esignature';
import { EsignatureType } from '~/enums/EsignatureType';
import { FileExtensionType } from '~/enums/FileExtensionType';

export const testIsFileExtensionSupported = (
  fileExtension: string,
  esignatureProvider: EsignatureType,
): boolean =>
  fileExtension === FileExtensionType.Docx ||
  supportedFileExtensions[esignatureProvider].includes(
    fileExtension.toLowerCase() as FileExtensionType,
  );
